import { useEffect, useState } from "react";
import { fieldTypes } from "@ucl/library";
import { useBoltApiClient } from "@bolt/core";
import { createBoltTaskApiClient } from "../../lib/apiClients/boltTaskApiClient";

export function useBoltTaskTypeActionOptions(): {
  taskExecutionTypeOptions: fieldTypes.Option<string>[];
} {
  const [taskExecutionTypeOptions, setTaskExecutionTypeOptions] = useState<
    fieldTypes.Option<string>[]
  >([]);
  const boltApiClient = useBoltApiClient();
  const taskApiClient = createBoltTaskApiClient(boltApiClient);

  useEffect(() => {
    const fetchTaskExecutionTypes = async () => {
      try {
        const types = await taskApiClient.getActionTypes();
        setTaskExecutionTypeOptions(types);
      } catch (err) {
        console.error("Failed to fetch task execution types:", err);
      }
    };

    fetchTaskExecutionTypes();
  }, []);

  return {
    taskExecutionTypeOptions,
  };
}
